import { render, staticRenderFns } from "./Replacement.vue?vue&type=template&id=6ee533d4&scoped=true&"
import script from "./Replacement.vue?vue&type=script&lang=js&"
export * from "./Replacement.vue?vue&type=script&lang=js&"
import style0 from "./Replacement.vue?vue&type=style&index=0&id=6ee533d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee533d4",
  null
  
)

export default component.exports